module.exports = __webpack_public_path__ + "static/media/coindodocard.8457ade5.webp";